export default "__VITE_ASSET__e72f0a3b__"